import { render, staticRenderFns } from "./EditInstitutionDetails.vue?vue&type=template&id=8fbf6a16"
import script from "./EditInstitutionDetails.vue?vue&type=script&lang=js"
export * from "./EditInstitutionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports